module.exports = __webpack_public_path__ + "fonts/HalisR-Thin.5b136af6.otf";